import MuiTableSortLabel, { TableSortLabelProps } from '@mui/material/TableSortLabel';

import { Icon, Icons } from 'Icon';

function TableSortLabel({ active, hideSortIcon = false, ...props }: TableSortLabelProps) {
  const icon = active ? Icons.circleDown : Icons.downSolid;

  return (
    <MuiTableSortLabel IconComponent={() => <Icon icon={icon} />} hideSortIcon={hideSortIcon} {...props} />
  );
}

export { TableHead, TableBody, TableCell } from './Table.styles';
export { TableSortLabel };
